import React from "react";
import Modal from "react-modal";
import currencyFormatter, { Currency } from "../../../../js/common/CurrencyFormatter";
import { ProductDetailInfo } from "../ProductDetailPageTypeConfig";
import sellTagService from "../../../../js/common/SellTagService";
import { SellTag } from "../../../../js/models/maxEnums";

interface ProductActionPriceInfoModalProperties {
    readonly productDetailInfo: ProductDetailInfo;
    readonly actionDiscountCode: string | null;
    readonly megaClearanceSaleDiscountCode: string | null;
    readonly newProductsDiscountCode: string | null;
    readonly onAfterClose: () => void;
    readonly currency: Currency;
}

const getTodayProductCode = (
    productDetailInfo: ProductDetailInfo,
    actionDiscountCode: string | null,
    megaClearanceSaleDiscountCode: string | null,
    newProductsDiscountCode: string | null,
): string => {
    if (sellTagService.contains(productDetailInfo.sellTags, SellTag.Promo) && actionDiscountCode !== null) {
        return actionDiscountCode;
    }

    if (sellTagService.contains(productDetailInfo.sellTags, SellTag.MegaClearanceSale) && megaClearanceSaleDiscountCode !== null) {
        return megaClearanceSaleDiscountCode;
    }

    if (sellTagService.contains(productDetailInfo.sellTags, SellTag.IsNew) && newProductsDiscountCode !== null) {
        return newProductsDiscountCode;
    }

    throw new Error(`Missing discount code for product ID ${productDetailInfo.productId} and sell tags ${productDetailInfo.sellTags}`);
};

const getDiv = (productDetailInfo: ProductDetailInfo, actionDiscountCode: string | null, newProductsDiscountCode: string | null): React.JSX.Element | undefined => {
    if (sellTagService.contains(productDetailInfo.sellTags, SellTag.Promo) && actionDiscountCode !== null) {
        return <p>Slevový kód bude aplikován automaticky po vložení do košíku.</p>;
    }

    if (sellTagService.contains(productDetailInfo.sellTags, SellTag.IsNew) && newProductsDiscountCode !== null) {
        return <p>Akční cenu získáte po zadání kódu <strong>{newProductsDiscountCode}</strong> v košíku.</p>;
    }

    return undefined;
};

export default function ProductActionPriceInfoModal({
    productDetailInfo,
    actionDiscountCode,
    megaClearanceSaleDiscountCode,
    newProductsDiscountCode,
    onAfterClose,
    currency,
}: ProductActionPriceInfoModalProperties): React.JSX.Element {
    const [modalIsOpen, setModalIsOpen] = React.useState(true);

    const closeModal = (): void => {
        setModalIsOpen(false);
    };

    return (
        <Modal
            isOpen={modalIsOpen}
            onAfterClose={onAfterClose}
            onRequestClose={closeModal}
            className="modal-dialog modal-transition"
            overlayClassName="react-modal-backdrop modal-transition"
        >
            <div className="modal-content">
                <div className="modal-header empty modal-header-image">
                    <button type="button" className="close" onClick={closeModal}>
                        <i className="fa-solid fa-times"></i>
                    </button>
                </div>
                <div className="modal-body action-price-modal-content">
                    <div className="well well-transparent">
                        <p className="fakeh3">Na tento produkt dnes akční cena</p>
                        <p className="title">{productDetailInfo.title}<span className="grey"> (varianta {productDetailInfo.productId})</span></p>
                        <p>Tento produkt koupíte dnes s
                            kódem <strong>{getTodayProductCode(productDetailInfo, actionDiscountCode, megaClearanceSaleDiscountCode, newProductsDiscountCode)}</strong> za akční
                            cenu {productDetailInfo.discountedPrice !== null && <span className="light-blue">
                            {currencyFormatter.formatCurrencyWithSymbol(productDetailInfo.discountedPrice, currency)}
                        </span>}.
                        </p>
                        <p>Cena bez slevového kódu: <strong>{currencyFormatter.formatCurrencyWithSymbol(productDetailInfo.price, currency)}</strong></p>
                        {getDiv(productDetailInfo, actionDiscountCode, newProductsDiscountCode)}
                        <button type="button" className="btn pull-right" onClick={closeModal}>Zavřít</button>
                        <div className="clearfix"></div>
                    </div>
                </div>
            </div>
        </Modal>
    );
}
